<template>
  <div class="wrapper">
    <dashboard-bar refreshButton />
    <div class="body">
      <div class="row no-gutters">
        <div class="col-lg-2">
          <span class="header-icon">
            <font-awesome-icon :icon="['fas', 'sync-alt']" />
          </span>
          <h2>{{ $t('treatments.pageTitle') }}</h2>
        </div>
      </div>
      <treatment-overview />
      <treatment-table />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import treatmentTable from '@/components/molecules/treatment-table';
import treatmentOverview from '@/components/molecules/treatment-overview';
import dashboardBar from '@/components/molecules/dashboard-bar';

export default {
  components: { treatmentTable, treatmentOverview, dashboardBar },

  computed: {
    ...mapState('authentication', ['userProfile']),
  },

  data: () => ({
    userAuth: null,
  }),

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    if (!this.userProfile.permissions.treatments.menu) {
      this.$router.push(`/dashboard/${this.userAuth.companyId}`);
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.wrapper {
  padding: 8px;
}

.refresh-icon {
  cursor: pointer;
  color: $primary;
  &:hover {
    color: rgb(97, 209, 97);
  }
}

.body {
  background-color: $white;
  padding: 16px;
  border: 1px solid $gray-light;
  border-radius: 4px;
}

.body h2 {
  text-transform: uppercase;
  font-size: 21px;
  font-weight: 100;
  color: $gray;
}

.header-icon {
  float: left;
  font-size: 12px;
  margin-top: 4px;
  padding-right: 12px;
  color: $gray;
}

.input-area {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  select {
    max-width: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/treatments/index.vue